<template>
  <div class="dealer-information">
    <summary-card
      :disabled="disabled"
      :summaryInformation="dealerInformation"
      :status="status"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

import { SummaryCard } from '../index';

import GenericReceivedObject from '../../models/utilities/generic-received-object.model';

import { TestDriveStatus } from '../../models/utilities/testdrive-status.enum';

export default defineComponent({
  name: 'otb-dealer-information',
  components: {
    SummaryCard,
  },
  props: {
    dealerInformation: {
      type: Array as () => GenericReceivedObject[],
    },
    disabled: Boolean,
    status: {
      type: String as () => TestDriveStatus,
      default: TestDriveStatus.BOOKED,
    },
  },
});
</script>
<style scoped src="./dealer-information.scss" lang="scss"></style>
